export const enCountriesList = [
  {
    standardizedName: "Mozambique",
    isoCountryCode: "MZ",
    name: "Mozambique",
  },
  {
    standardizedName: "France",
    isoCountryCode: "FR",
    name: "France",
  },
  {
    standardizedName: "Tonga",
    isoCountryCode: "TO",
    name: "Tonga",
  },
  {
    standardizedName: "Ireland",
    isoCountryCode: "IE",
    name: "Ireland",
  },
  {
    standardizedName: "Greece",
    isoCountryCode: "GR",
    name: "Greece",
  },
  {
    standardizedName: "Peru",
    isoCountryCode: "PE",
    name: "Peru",
  },
  {
    standardizedName: "Lithuania",
    isoCountryCode: "LT",
    name: "Lithuania",
  },
  {
    standardizedName: "Qatar",
    isoCountryCode: "QA",
    name: "Qatar",
  },
  {
    standardizedName: "Comoros",
    isoCountryCode: "KM",
    name: "Comoros",
  },
  {
    standardizedName: "Myanmar",
    isoCountryCode: "MM",
    name: "Myanmar (Burma)",
  },
  {
    standardizedName: "Senegal",
    isoCountryCode: "SN",
    name: "Senegal",
  },
  {
    standardizedName: "Gambia",
    isoCountryCode: "GM",
    name: "Gambia",
  },
  {
    standardizedName: "Andorra",
    isoCountryCode: "AD",
    name: "Andorra",
  },
  {
    standardizedName: "Saint Kitts and Nevis",
    isoCountryCode: "KN",
    name: "St. Kitts & Nevis",
  },
  {
    standardizedName: "Cambodia",
    isoCountryCode: "KH",
    name: "Cambodia",
  },
  {
    standardizedName: "Thailand",
    isoCountryCode: "TH",
    name: "Thailand",
  },
  {
    standardizedName: "Cayman Islands",
    isoCountryCode: "KY",
    name: "Cayman Islands",
  },
  {
    standardizedName: "New Caledonia",
    isoCountryCode: "NC",
    name: "New Caledonia",
  },
  {
    standardizedName: "Sint Maarten",
    isoCountryCode: "SX",
    name: "Sint Maarten",
  },
  {
    standardizedName: "Suriname",
    isoCountryCode: "SR",
    name: "Suriname",
  },
  {
    standardizedName: "Kosovo",
    isoCountryCode: "XK",
    name: "Kosovo",
  },
  {
    standardizedName: "Kuwait",
    isoCountryCode: "KW",
    name: "Kuwait",
  },
  {
    standardizedName: "Micronesia, Federated States of",
    isoCountryCode: "FM",
    name: "Micronesia",
  },
  {
    standardizedName: "Jordan",
    isoCountryCode: "JO",
    name: "Jordan",
  },
  {
    standardizedName: "Uganda",
    isoCountryCode: "UG",
    name: "Uganda",
  },
  {
    standardizedName: "Singapore",
    isoCountryCode: "SG",
    name: "Singapore",
  },
  {
    standardizedName: "Equatorial Guinea",
    isoCountryCode: "GQ",
    name: "Equatorial Guinea",
  },
  {
    standardizedName: "Bosnia and Herzegovina",
    isoCountryCode: "BA",
    name: "Bosnia & Herzegovina",
  },
  {
    standardizedName: "Tanzania, United Republic Of",
    isoCountryCode: "TZ",
    name: "Tanzania",
  },
  {
    standardizedName: "New Zealand",
    isoCountryCode: "NZ",
    name: "New Zealand",
  },
  {
    standardizedName: "Aruba",
    isoCountryCode: "AW",
    name: "Aruba",
  },
  {
    standardizedName: "Macedonia, The Former Yugoslav Republic of",
    isoCountryCode: "MK",
    name: "North Macedonia",
  },
  {
    standardizedName: "Togo",
    isoCountryCode: "TG",
    name: "Togo",
  },
  {
    standardizedName: "Zimbabwe",
    isoCountryCode: "ZW",
    name: "Zimbabwe",
  },
  {
    standardizedName: "Sri Lanka",
    isoCountryCode: "LK",
    name: "Sri Lanka",
  },
  {
    standardizedName: "Malawi",
    isoCountryCode: "MW",
    name: "Malawi",
  },
  {
    standardizedName: "Dominica",
    isoCountryCode: "DM",
    name: "Dominica",
  },
  {
    standardizedName: "United Kingdom",
    isoCountryCode: "GB",
    name: "United Kingdom",
  },
  {
    standardizedName: "Latvia",
    isoCountryCode: "LV",
    name: "Latvia",
  },
  {
    standardizedName: "Bolivia",
    isoCountryCode: "BO",
    name: "Bolivia",
  },
  {
    standardizedName: "Israel",
    isoCountryCode: "IL",
    name: "Israel",
  },
  {
    standardizedName: "Congo, The Democratic Republic Of The",
    isoCountryCode: "CD",
    name: "Congo - Kinshasa",
  },
  {
    standardizedName: "Belize",
    isoCountryCode: "BZ",
    name: "Belize",
  },
  {
    standardizedName: "Mauritania",
    isoCountryCode: "MR",
    name: "Mauritania",
  },
  {
    standardizedName: "Vanuatu",
    isoCountryCode: "VU",
    name: "Vanuatu",
  },
  {
    standardizedName: "Vietnam",
    isoCountryCode: "VN",
    name: "Vietnam",
  },
  {
    standardizedName: "Iceland",
    isoCountryCode: "IS",
    name: "Iceland",
  },
  {
    standardizedName: "Montenegro",
    isoCountryCode: "ME",
    name: "Montenegro",
  },
  {
    standardizedName: "Paraguay",
    isoCountryCode: "PY",
    name: "Paraguay",
  },
  {
    standardizedName: "Fiji",
    isoCountryCode: "FJ",
    name: "Fiji",
  },
  {
    standardizedName: "Brazil",
    isoCountryCode: "BR",
    name: "Brazil",
  },
  {
    standardizedName: "Portugal",
    isoCountryCode: "PT",
    name: "Portugal",
  },
  {
    standardizedName: "Cameroon",
    isoCountryCode: "CM",
    name: "Cameroon",
  },
  {
    standardizedName: "Cuba",
    isoCountryCode: "CU",
    name: "Cuba",
  },
  {
    standardizedName: "Oman",
    isoCountryCode: "OM",
    name: "Oman",
  },
  {
    standardizedName: "Belgium",
    isoCountryCode: "BE",
    name: "Belgium",
  },
  {
    standardizedName: "Morocco",
    isoCountryCode: "MA",
    name: "Morocco",
  },
  {
    standardizedName: "Nauru",
    isoCountryCode: "NR",
    name: "Nauru",
  },
  {
    standardizedName: "Niger",
    isoCountryCode: "NE",
    name: "Niger",
  },
  {
    standardizedName: "Congo, Republic of the",
    isoCountryCode: "CG",
    name: "Congo - Brazzaville",
  },
  {
    standardizedName: "Venezuela",
    isoCountryCode: "VE",
    name: "Venezuela",
  },
  {
    standardizedName: "Colombia",
    isoCountryCode: "CO",
    name: "Colombia",
  },
  {
    standardizedName: "Costa Rica",
    isoCountryCode: "CR",
    name: "Costa Rica",
  },
  {
    standardizedName: "Gabon",
    isoCountryCode: "GA",
    name: "Gabon",
  },
  {
    standardizedName: "Angola",
    isoCountryCode: "AO",
    name: "Angola",
  },
  {
    standardizedName: "Slovenia",
    isoCountryCode: "SI",
    name: "Slovenia",
  },
  {
    standardizedName: "Rwanda",
    isoCountryCode: "RW",
    name: "Rwanda",
  },
  {
    standardizedName: "Sao Tome & Principe",
    isoCountryCode: "ST",
    name: "São Tomé & Príncipe",
  },
  {
    standardizedName: "Cyprus",
    isoCountryCode: "CY",
    name: "Cyprus",
  },
  {
    standardizedName: "United States of America",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    standardizedName: "Tuvalu",
    isoCountryCode: "TV",
    name: "Tuvalu",
  },
  {
    standardizedName: "Chile",
    isoCountryCode: "CL",
    name: "Chile",
  },
  {
    standardizedName: "United States",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    standardizedName: "Moldova, Republic of",
    isoCountryCode: "MD",
    name: "Moldova",
  },
  {
    standardizedName: "Saudi Arabia",
    isoCountryCode: "SA",
    name: "Saudi Arabia",
  },
  {
    standardizedName: "Nepal",
    isoCountryCode: "NP",
    name: "Nepal",
  },
  {
    standardizedName: "Bahrain",
    isoCountryCode: "BH",
    name: "Bahrain",
  },
  {
    standardizedName: "Viet Nam",
    isoCountryCode: "VN",
    name: "Vietnam",
  },
  {
    standardizedName: "Slovakia",
    isoCountryCode: "SK",
    name: "Slovakia",
  },
  {
    standardizedName: "Kazakhstan",
    isoCountryCode: "KZ",
    name: "Kazakhstan",
  },
  {
    standardizedName: "Mali",
    isoCountryCode: "ML",
    name: "Mali",
  },
  {
    standardizedName: "Uruguay",
    isoCountryCode: "UY",
    name: "Uruguay",
  },
  {
    standardizedName: "Indonesia",
    isoCountryCode: "ID",
    name: "Indonesia",
  },
  {
    standardizedName: "China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Guinea-Bissau",
    isoCountryCode: "GW",
    name: "Guinea-Bissau",
  },
  {
    standardizedName: "Marshall Islands",
    isoCountryCode: "MH",
    name: "Marshall Islands",
  },
  {
    standardizedName: "Kenya",
    isoCountryCode: "KE",
    name: "Kenya",
  },
  {
    standardizedName: "Syrian Arab Republic",
    isoCountryCode: "SY",
    name: "Syria",
  },
  {
    standardizedName: "US",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    standardizedName: "South Sudan",
    isoCountryCode: "SS",
    name: "South Sudan",
  },
  {
    standardizedName: "Croatia",
    isoCountryCode: "HR",
    name: "Croatia",
  },
  {
    standardizedName: "Albania",
    isoCountryCode: "AL",
    name: "Albania",
  },
  {
    standardizedName: "Jamaica",
    isoCountryCode: "JM",
    name: "Jamaica",
  },
  {
    standardizedName: "Denmark",
    isoCountryCode: "DK",
    name: "Denmark",
  },
  {
    standardizedName: "Antigua and Barbuda",
    isoCountryCode: "AG",
    name: "Antigua & Barbuda",
  },
  {
    standardizedName: "Nicaragua",
    isoCountryCode: "NI",
    name: "Nicaragua",
  },
  {
    standardizedName: "Libyan Arab Jamahiriya",
    isoCountryCode: "LY",
    name: "Libya",
  },
  {
    standardizedName: "Burundi",
    isoCountryCode: "BI",
    name: "Burundi",
  },
  {
    standardizedName: "Bermuda",
    isoCountryCode: "BM",
    name: "Bermuda",
  },
  {
    standardizedName: "Italy",
    isoCountryCode: "IT",
    name: "Italy",
  },
  {
    standardizedName: "Puerto Rico",
    isoCountryCode: "PR",
    name: "Puerto Rico",
  },
  {
    standardizedName: "Chad",
    isoCountryCode: "TD",
    name: "Chad",
  },
  {
    standardizedName: "Turkmenistan",
    isoCountryCode: "TM",
    name: "Turkmenistan",
  },
  {
    standardizedName: "Haiti",
    isoCountryCode: "HT",
    name: "Haiti",
  },
  {
    standardizedName: "Benin",
    isoCountryCode: "BJ",
    name: "Benin",
  },
  {
    standardizedName: "Macao",
    isoCountryCode: "MO",
    name: "Macao SAR China",
  },
  {
    standardizedName: "Germany",
    isoCountryCode: "DE",
    name: "Germany",
  },
  {
    standardizedName: "Romania",
    isoCountryCode: "RO",
    name: "Romania",
  },
  {
    standardizedName: "Malaysia",
    isoCountryCode: "MY",
    name: "Malaysia",
  },
  {
    standardizedName: "Palestinian Territory, Occupied",
    isoCountryCode: "PS",
    name: "Palestinian Territories",
  },
  {
    standardizedName: "Ethiopia",
    isoCountryCode: "ET",
    name: "Ethiopia",
  },
  {
    standardizedName: "Bhutan",
    isoCountryCode: "BT",
    name: "Bhutan",
  },
  {
    standardizedName: "Guyana",
    isoCountryCode: "GY",
    name: "Guyana",
  },
  {
    standardizedName: "Saint Lucia",
    isoCountryCode: "LC",
    name: "St. Lucia",
  },
  {
    standardizedName: "Djibouti",
    isoCountryCode: "DJ",
    name: "Djibouti",
  },
  {
    standardizedName: "Swaziland",
    isoCountryCode: "SZ",
    name: "Eswatini",
  },
  {
    standardizedName: "Liberia",
    isoCountryCode: "LR",
    name: "Liberia",
  },
  {
    standardizedName: "Cape Verde",
    isoCountryCode: "CV",
    name: "Cape Verde",
  },
  {
    standardizedName: "Azerbaijan",
    isoCountryCode: "AZ",
    name: "Azerbaijan",
  },
  {
    standardizedName: "Switzerland",
    isoCountryCode: "CH",
    name: "Switzerland",
  },
  {
    standardizedName: "China, People's Republic of",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Papua New Guinea",
    isoCountryCode: "PG",
    name: "Papua New Guinea",
  },
  {
    standardizedName: "Algeria",
    isoCountryCode: "DZ",
    name: "Algeria",
  },
  {
    standardizedName: "Yemen",
    isoCountryCode: "YE",
    name: "Yemen",
  },
  {
    standardizedName: "Luxembourg",
    isoCountryCode: "LU",
    name: "Luxembourg",
  },
  {
    standardizedName: "Norway",
    isoCountryCode: "NO",
    name: "Norway",
  },
  {
    standardizedName: "Nigeria",
    isoCountryCode: "NG",
    name: "Nigeria",
  },
  {
    standardizedName: "American Samoa",
    isoCountryCode: "AS",
    name: "American Samoa",
  },
  {
    standardizedName: "Saint Vincent and the Grenadines",
    isoCountryCode: "VC",
    name: "St. Vincent & Grenadines",
  },
  {
    standardizedName: "India",
    isoCountryCode: "IN",
    name: "India",
  },
  {
    standardizedName: "Palau",
    isoCountryCode: "PW",
    name: "Palau",
  },
  {
    standardizedName: "Tunisia",
    isoCountryCode: "TN",
    name: "Tunisia",
  },
  {
    standardizedName: "Bangladesh",
    isoCountryCode: "BD",
    name: "Bangladesh",
  },
  {
    standardizedName: "French Polynesia",
    isoCountryCode: "PF",
    name: "French Polynesia",
  },
  {
    standardizedName: "Sierra Leone",
    isoCountryCode: "SL",
    name: "Sierra Leone",
  },
  {
    standardizedName: "Burkina Faso",
    isoCountryCode: "BF",
    name: "Burkina Faso",
  },
  {
    standardizedName: "Japan",
    isoCountryCode: "JP",
    name: "Japan",
  },
  {
    standardizedName: "Trinidad and Tobago",
    isoCountryCode: "TT",
    name: "Trinidad & Tobago",
  },
  {
    standardizedName: "Ecuador",
    isoCountryCode: "EC",
    name: "Ecuador",
  },
  {
    standardizedName: "Panama",
    isoCountryCode: "PA",
    name: "Panama",
  },
  {
    standardizedName: "Ghana",
    isoCountryCode: "GH",
    name: "Ghana",
  },
  {
    standardizedName: "Pakistan",
    isoCountryCode: "PK",
    name: "Pakistan",
  },
  {
    standardizedName: "Bulgaria",
    isoCountryCode: "BG",
    name: "Bulgaria",
  },
  {
    standardizedName: "Seychelles",
    isoCountryCode: "SC",
    name: "Seychelles",
  },
  {
    standardizedName: "Malta",
    isoCountryCode: "MT",
    name: "Malta",
  },
  {
    standardizedName: "UK",
    isoCountryCode: "GB",
    name: "United Kingdom",
  },
  {
    standardizedName: "Iraq",
    isoCountryCode: "IQ",
    name: "Iraq",
  },
  {
    standardizedName: "People’s Republic of China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    standardizedName: "Curaçao",
    isoCountryCode: "CW",
    name: "Curaçao",
  },
  {
    standardizedName: "Virgin Islands, U.S.",
    isoCountryCode: "VI",
    name: "U.S. Virgin Islands",
  },
  {
    standardizedName: "Sweden",
    isoCountryCode: "SE",
    name: "Sweden",
  },
  {
    standardizedName: "United Arab Emirates",
    isoCountryCode: "AE",
    name: "United Arab Emirates",
  },
  {
    standardizedName: "Eritrea",
    isoCountryCode: "ER",
    name: "Eritrea",
  },
  {
    standardizedName: "Spain",
    isoCountryCode: "ES",
    name: "Spain",
  },
  {
    standardizedName: "Guinea",
    isoCountryCode: "GN",
    name: "Guinea",
  },
  {
    standardizedName: "Hong Kong",
    isoCountryCode: "HK",
    name: "Hong Kong SAR China",
  },
  {
    standardizedName: "Isle of Man",
    isoCountryCode: "IM",
    name: "Isle of Man",
  },
  {
    standardizedName: "Argentina",
    isoCountryCode: "AR",
    name: "Argentina",
  },
  {
    standardizedName: "Dominican Republic",
    isoCountryCode: "DO",
    name: "Dominican Republic",
  },
  {
    standardizedName: "Zambia",
    isoCountryCode: "ZM",
    name: "Zambia",
  },
  {
    standardizedName: "Austria",
    isoCountryCode: "AT",
    name: "Austria",
  },
  {
    standardizedName: "Australia",
    isoCountryCode: "AU",
    name: "Australia",
  },
  {
    standardizedName: "Kiribati",
    isoCountryCode: "KI",
    name: "Kiribati",
  },
  {
    standardizedName: "Grenada",
    isoCountryCode: "GD",
    name: "Grenada",
  },
  {
    standardizedName: "Kyrgyzstan",
    isoCountryCode: "KG",
    name: "Kyrgyzstan",
  },
  {
    standardizedName: "Madagascar",
    isoCountryCode: "MG",
    name: "Madagascar",
  },
  {
    standardizedName: "Egypt",
    isoCountryCode: "EG",
    name: "Egypt",
  },
  {
    standardizedName: "Korea, Republic of",
    isoCountryCode: "KR",
    name: "South Korea",
  },
  {
    standardizedName: "Brunei Darussalam",
    isoCountryCode: "BN",
    name: "Brunei",
  },
  {
    standardizedName: "Ukraine",
    isoCountryCode: "UA",
    name: "Ukraine",
  },
  {
    standardizedName: "Bahamas",
    isoCountryCode: "BS",
    name: "Bahamas",
  },
  {
    standardizedName: "Samoa",
    isoCountryCode: "WS",
    name: "Samoa",
  },
  {
    standardizedName: "Armenia",
    isoCountryCode: "AM",
    name: "Armenia",
  },
  {
    standardizedName: "Côte d'Ivoire",
    isoCountryCode: "CI",
    name: "Côte d’Ivoire",
  },
  {
    standardizedName: "Georgia",
    isoCountryCode: "GE",
    name: "Georgia",
  },
  {
    standardizedName: "Lao People's Democratic Republic",
    isoCountryCode: "LA",
    name: "Laos",
  },
  {
    standardizedName: "Taiwan",
    isoCountryCode: "TW",
    name: "Taiwan",
  },
  {
    standardizedName: "Russian Federation",
    isoCountryCode: "RU",
    name: "Russia",
  },
  {
    standardizedName: "Finland",
    isoCountryCode: "FI",
    name: "Finland",
  },
  {
    standardizedName: "Afghanistan",
    isoCountryCode: "AF",
    name: "Afghanistan",
  },
  {
    standardizedName: "Faroe Islands",
    isoCountryCode: "FO",
    name: "Faroe Islands",
  },
  {
    standardizedName: "Jersey",
    isoCountryCode: "JE",
    name: "Jersey",
  },
  {
    standardizedName: "Mexico",
    isoCountryCode: "MX",
    name: "Mexico",
  },
  {
    standardizedName: "Tajikistan",
    isoCountryCode: "TJ",
    name: "Tajikistan",
  },
  {
    standardizedName: "Botswana",
    isoCountryCode: "BW",
    name: "Botswana",
  },
  {
    standardizedName: "Korea, Democratic People's Republic of",
    isoCountryCode: "KP",
    name: "North Korea",
  },
  {
    standardizedName: "Czech Republic",
    isoCountryCode: "CZ",
    name: "Czechia",
  },
  {
    standardizedName: "Canada",
    isoCountryCode: "CA",
    name: "Canada",
  },
  {
    standardizedName: "Greenland",
    isoCountryCode: "GL",
    name: "Greenland",
  },
  {
    standardizedName: "Mauritius",
    isoCountryCode: "MU",
    name: "Mauritius",
  },
  {
    standardizedName: "Liechtenstein",
    isoCountryCode: "LI",
    name: "Liechtenstein",
  },
  {
    standardizedName: "Honduras",
    isoCountryCode: "HN",
    name: "Honduras",
  },
  {
    standardizedName: "Sudan",
    isoCountryCode: "SD",
    name: "Sudan",
  },
  {
    standardizedName: "Philippines",
    isoCountryCode: "PH",
    name: "Philippines",
  },
  {
    standardizedName: "Netherlands",
    isoCountryCode: "NL",
    name: "Netherlands",
  },
  {
    standardizedName: "Belarus",
    isoCountryCode: "BY",
    name: "Belarus",
  },
  {
    standardizedName: "Poland",
    isoCountryCode: "PL",
    name: "Poland",
  },
  {
    standardizedName: "Mongolia",
    isoCountryCode: "MN",
    name: "Mongolia",
  },
  {
    standardizedName: "Monaco",
    isoCountryCode: "MC",
    name: "Monaco",
  },
  {
    standardizedName: "Guatemala",
    isoCountryCode: "GT",
    name: "Guatemala",
  },
  {
    standardizedName: "Iran, Islamic Republic of",
    isoCountryCode: "IR",
    name: "Iran",
  },
  {
    standardizedName: "Uzbekistan",
    isoCountryCode: "UZ",
    name: "Uzbekistan",
  },
  {
    standardizedName: "Namibia",
    isoCountryCode: "NA",
    name: "Namibia",
  },
  {
    standardizedName: "Solomon Islands",
    isoCountryCode: "SB",
    name: "Solomon Islands",
  },
  {
    standardizedName: "El Salvador",
    isoCountryCode: "SV",
    name: "El Salvador",
  },
  {
    standardizedName: "Hungary",
    isoCountryCode: "HU",
    name: "Hungary",
  },
  {
    standardizedName: "Estonia",
    isoCountryCode: "EE",
    name: "Estonia",
  },
  {
    standardizedName: "Guam",
    isoCountryCode: "GU",
    name: "Guam",
  },
  {
    standardizedName: "Maldives",
    isoCountryCode: "MV",
    name: "Maldives",
  },
  {
    standardizedName: "Somalia",
    isoCountryCode: "SO",
    name: "Somalia",
  },
  {
    standardizedName: "Northern Mariana Islands",
    isoCountryCode: "MP",
    name: "Northern Mariana Islands",
  },
  {
    standardizedName: "Russia",
    isoCountryCode: "RU",
    name: "Russia",
  },
  {
    standardizedName: "South Africa",
    isoCountryCode: "ZA",
    name: "South Africa",
  },
  {
    standardizedName: "Lesotho",
    isoCountryCode: "LS",
    name: "Lesotho",
  },
];
